import React from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCog } from '@fortawesome/free-solid-svg-icons';

const SettingsPage: React.FC = () => {
    return (
        <Container fluid className="py-4 px-4">
            <Row className="mb-4">
                <Col>
                    <h2 className="fw-bold">Settings</h2>
                    <p className="text-muted">Configure application settings</p>
                </Col>
            </Row>

            <Row className="justify-content-center mt-5">
                <Col xs={12} md={6} className="text-center">
                    <FontAwesomeIcon
                        icon={faCog}
                        size="4x"
                        className="text-muted mb-3"
                    />
                    <h4 className="text-muted">Coming Soon</h4>
                    <p className="text-muted">
                        Application settings will be available in a future update.
                    </p>
                </Col>
            </Row>
        </Container>
    );
};

export default SettingsPage;
